[
    {
        "auth": false,
        "userType": "any",
        "links": [
            {
                "code": "home",
                "label": "/home",
                "value": "home"
            }
        ]
    },
    {
        "auth": true,
        "userType": "client",
        "links": [
            {
                "code": "dashboard",
                "value": "dashboard",
                "label": "/dashboard",
                "icon": "Dashboard"
            }
        ]
    },
    {
        "auth": true,
        "userType": "broker",
        "links": [
            {
                "code": "policies",
                "value": "policies",
                "label": "Policies",
                "icon": "Policies"
            },
            {
                "code": "newquote",
                "label": "New Quote",
                "icon": "Newquote",
                "value": "newquote"
            },
            {
                "code": "leads",
                "label": "Leads",
                "icon": "Leads",
                "value": "leads"
            }
        ]
    },
    {
        "auth": true,
        "userType": "administrator",
        "links": [
            {
                "code": "policies",
                "label": "Policies",
                "value": "policies",
                "icon": "Policies"
            },
            {
                "code": "bordereaux",
                "label": "Bordereaux",
                "value": "bordereaux",
                "icon": "Bordereaux"
            },
            {
                "code": "newquote",
                "label": "New Quote",
                "icon": "Newquote",
                "value": "newquote"
            },
            {
                "code": "search",
                "label": "Clients",
                "value": "search",
                "icon": "Clients"
            },
            {
                "code": "leads",
                "label": "Leads",
                "value": "leads",
                "icon": "Leads"
            }
        ]
    }
]
